$(document).ready(function () {
    $('#birth-month').keyup(function (event) {
        if (isEnterKeyPressed(event)) {
            AgeGate.AgeCheck();
        } else if ($(this).val().length === 2 && event.key !== 'Tab' && event.key !== 'Shift') {
            $('#birth-day').focus();
        }
    });

    $('#birth-day').keyup(function (event) {
        if (isEnterKeyPressed(event)) {
            AgeGate.AgeCheck();
        } else if ($(this).val().length === 2 && event.key !== 'Tab' && event.key !== 'Shift') {
            $('#birth-year').focus();
        }
    });

    $('#birth-year').keyup(function (event) {
        if (isEnterKeyPressed(event)) {
            AgeCheck();
        }
    });

    function  validateInputLength(input, maxLength) {
        input.on('keydown keyup change', function(){
            var char = $(this).val();
            var charLength = $(this).val().length;
           if(charLength > maxLength){
                $(this).val(char.substring(0, maxLength));
            }
        });
    }

    validateInputLength($('#birth-month'), 2 );
    validateInputLength($('#birth-day'), 2 );
    validateInputLength($('#birth-year'), 4 );

    $('.agegate-submit').click(function (e) {
        AgeCheck();
    });
    function isEnterKeyPressed(event) {
        const code = event.which;
        if (code === 13) {
            return true;
        }
        return false;
    }

   function updateErrorMessageAgeGate ( year, month, day, theirDate, today, ageBeyondOldest) {
        let errWrapper, errTemplate, errSpan, dayVal, monthVal, yearVal, dayEl,
            monthEl, yearEl, dobEl, ageEl, dayNotValid, monthNotValid, yearNotValid;

        errTemplate = document.querySelector('.agegate-error-template');
        errWrapper = document.querySelector('.agegate-errors-wrapper');

        errSpan = document.createElement('span');
        errSpan.classList.add('age-gate__error');

        dayVal = document.querySelector('#birth-day').value;
        monthVal = document.querySelector('#birth-month').value;
        yearVal = document.querySelector('#birth-year').value;
        dayEl = errTemplate.content.querySelector('.error-day');
        monthEl = errTemplate.content.querySelector('.error-month');
        yearEl = errTemplate.content.querySelector('.error-year');
        dobEl = errTemplate.content.querySelector('.error-valid-dob');
        ageEl = errTemplate.content.querySelector('.error-age');
        dayNotValid = errTemplate.content.querySelector('.error-day-notvalid');
        monthNotValid = errTemplate.content.querySelector('.error-month-notvalid');
        yearNotValid = errTemplate.content.querySelector('.error-year-notvalid');

        if (typeof (document.querySelector(`.age-gate__error`)) != 'undefined' && document.querySelector(`.age-gate__error`) !== null) {
            document.querySelector(`.age-gate__error`).remove();
        }

        dayVal.length === 0 && !isNaN(dayVal) ?  dayEl.classList.remove('d-none'):  dayEl.classList.add('d-none');
        dayVal.length > 0 && isNaN(dayVal) ? dayNotValid.classList.remove('d-none') : dayNotValid.classList.add('d-none');

        monthVal.length === 0 && !isNaN(monthVal) ?  monthEl.classList.remove('d-none'):  monthEl.classList.add('d-none');
        monthVal.length > 0 && isNaN(monthVal) ? monthNotValid.classList.remove('d-none') : monthNotValid.classList.add('d-none');

        yearVal.length === 0 && !isNaN(yearVal) ?  yearEl.classList.remove('d-none'):  yearEl.classList.add('d-none');
        yearVal.length > 0 && isNaN(yearVal) ? yearNotValid.classList.remove('d-none') : yearNotValid.classList.add('d-none');

        const isAgeValid = dobEl.classList.contains('d-none');

        ((today.getTime() - theirDate.getTime()) < 0) && isAgeValid ? ageEl.classList.remove('d-none') : ageEl.classList.add('d-none');

        if((year > today.getFullYear() || year < ageBeyondOldest) ||
            ( month > 12 || month < 1) ||
            (day > 31 || day < 1)){

            dobEl.classList.remove('d-none');
        }else{
            dobEl.classList.add('d-none');
        }


        const  clone = errTemplate.content.querySelector('div').cloneNode(true);
        errSpan.appendChild(clone);
        errWrapper.appendChild(errSpan);
    }

    function AgeCheck() {
        const min_age = 21; // Set the minimum age.
        const year = parseInt(document.getElementById('birth-year').value);
        let month = parseInt(document.getElementById('birth-month').value);
        const day = parseInt(document.getElementById('birth-day').value);
        const userDob = (year + "-" + month + "-" + day);
        const theirDate = new Date((year + min_age), month - 1, day);
        const today = new Date();
        const ageBeyondOldest = today.getFullYear() - 125;


        if ((isNaN(year) || ((year > today.getFullYear() || year < ageBeyondOldest))) ||
            (isNaN(month) || ((month > 12 || month < 1))) ||
            (isNaN(day) || ((day > 31 || day < 1)))) {
            return   updateErrorMessageAgeGate(year, month, day, theirDate, today, ageBeyondOldest);
        } else {
            $('#error-message').removeClass('d-block');
        }

        if ((today.getTime() - theirDate.getTime()) < 0) {

            updateErrorMessageAgeGate(year, month, day, theirDate, today, ageBeyondOldest);

            setTimeout(function () {
                window.location = 'http://www.dontserveteens.gov/'; // enter domain url where you would like the underaged visitor to be sent to.
            }, 5000);

        } else  {
            Cookies.set('AgeGate', 'Passed', {expires: 1, path: '/'})
            Cookies.set('AV_date', userDob, {expires: 1, path: '/'})

            function extractDomain(url) {
                let a = document.createElement('a');
                a.href = url;
                return a.hostname;
            }

            let currentUrl = window.location.href;
            let currentDomain = extractDomain(currentUrl);

            let referrerUrl = document.referrer;
            let referrerDomain = extractDomain(referrerUrl);

            if (referrerUrl && !referrerUrl.includes('age-gate') && referrerDomain === currentDomain) {
                location.href = referrerUrl;
            } else {
                location.href = "/";
            }
        }

    }

});

